/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckDocumentSidesExpectation {
    DATA_PAGE = 'DATA_PAGE',
    CARD_FRONT = 'CARD_FRONT',
    CARD_BACK = 'CARD_BACK',
    ALL = 'ALL'
}


export function instanceOfPaxCheckDocumentSidesExpectation(value: any): boolean {
    for (const key in PaxCheckDocumentSidesExpectation) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckDocumentSidesExpectation, key)) {
            if (PaxCheckDocumentSidesExpectation[key as keyof typeof PaxCheckDocumentSidesExpectation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckDocumentSidesExpectationFromJSON(json: any): PaxCheckDocumentSidesExpectation {
    return PaxCheckDocumentSidesExpectationFromJSONTyped(json, false);
}

export function PaxCheckDocumentSidesExpectationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentSidesExpectation {
    return json as PaxCheckDocumentSidesExpectation;
}

export function PaxCheckDocumentSidesExpectationToJSON(value?: PaxCheckDocumentSidesExpectation | null): any {
    return value as any;
}

export function PaxCheckDocumentSidesExpectationToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckDocumentSidesExpectation {
    return value as PaxCheckDocumentSidesExpectation;
}

